<table mat-table matSort [dataSource]="dataSource">
    <ng-container matColumnDef="image">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="image" class="cell_medium"> Aperçu</th>
      <td mat-cell *matCellDef="let element" class="cell_medium">
        <div class="img"><img [src]="element.image" alt=""></div>
      </td>
    </ng-container>

    <ng-container matColumnDef="title">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="title"> Titre
      </th>
      <td mat-cell *matCellDef="let element"> {{element?.title}} </td>
    </ng-container>

    <ng-container matColumnDef="nbrOfRating">
      <th mat-header-cell *matHeaderCellDef class="cell_action"> Nombre de votes </th>
      <td mat-cell *matCellDef="let element" class="cell_action"> {{element?.ratingsNumber}} </td>
    </ng-container>

    <ng-container matColumnDef="rating">
      <th mat-header-cell *matHeaderCellDef  class="cell_action"> Appréciation </th>
      <td mat-cell *matCellDef="let element" class="cell_action">
        <ng-rating-bar [matTooltip]="element?.ratingsAverage?.toFixed(2) + '/5'" [value]="element?.ratingsAverage" [disabled]="true" [ratingCount]="5"></ng-rating-bar>
      </td>
    </ng-container>
    <ng-container matColumnDef="disturbing">
      <th mat-header-cell *matHeaderCellDef  class="cell_action"> Coté dérangeant </th>
      <td mat-cell *matCellDef="let element" class="cell_action">
        <ng-rating-bar [matTooltip]="element?.disturbingAverage?.toFixed(2) + '/5'" [value]="element?.disturbingAverage" [disabled]="true" [ratingCount]="5"></ng-rating-bar>
      </td>
    </ng-container>

    <ng-container matColumnDef="expand">
      <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button aria-label="expand row" (click)="(subMovies = subMovies === element ? null : element); $event.stopPropagation()">
          <mat-icon *ngIf="subMovies !== element">keyboard_arrow_down</mat-icon>
          <mat-icon *ngIf="subMovies === element">keyboard_arrow_up</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumnsDesktop"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumnsDesktop;"> </tr>
  </table>